import { SafeInputPlugin, FlatMetaPlugin } from 'unhead/plugins';
import { walkResolver } from 'unhead/utils';
import { hasInjectionContext, inject, ref, watchEffect, getCurrentInstance, onBeforeUnmount, onDeactivated, onActivated } from 'vue';
import { h as headSymbol } from './vue.Kp0sxz0n.mjs';
import { V as VueResolver } from './vue.N9zWjxoK.mjs';

// @__NO_SIDE_EFFECTS__
function injectHead() {
  if (hasInjectionContext()) {
    const instance = inject(headSymbol);
    if (!instance) {
      throw new Error("useHead() was called without provide context, ensure you call it through the setup() function.");
    }
    return instance;
  }
  throw new Error("useHead() was called without provide context, ensure you call it through the setup() function.");
}
// @__NO_SIDE_EFFECTS__
function useHead(input, options = {}) {
  const head = options.head || /* @__PURE__ */ injectHead();
  return head.ssr ? head.push(input || {}, options) : /* @__PURE__ */ clientUseHead(head, input, options);
}
// @__NO_SIDE_EFFECTS__
function clientUseHead(head, input, options = {}) {
  const deactivated = ref(false);
  let entry;
  watchEffect(() => {
    const i = deactivated.value ? {} : walkResolver(input, VueResolver);
    if (entry) {
      entry.patch(i);
    } else {
      entry = head.push(i, options);
    }
  });
  const vm = getCurrentInstance();
  if (vm) {
    onBeforeUnmount(() => {
      entry.dispose();
    });
    onDeactivated(() => {
      deactivated.value = true;
    });
    onActivated(() => {
      deactivated.value = false;
    });
  }
  return entry;
}
// @__NO_SIDE_EFFECTS__
function useHeadSafe(input = {}, options = {}) {
  const head = options.head || /* @__PURE__ */ injectHead();
  head.use(SafeInputPlugin);
  options._safe = true;
  return /* @__PURE__ */ useHead(input, options);
}
// @__NO_SIDE_EFFECTS__
function useSeoMeta(input = {}, options = {}) {
  const head = options.head || /* @__PURE__ */ injectHead();
  head.use(FlatMetaPlugin);
  const { title, titleTemplate, ...meta } = input;
  return /* @__PURE__ */ useHead({
    title,
    titleTemplate,
    _flatMeta: meta
  }, options);
}
// @__NO_SIDE_EFFECTS__
function useServerHead(input, options = {}) {
  return /* @__PURE__ */ useHead(input, { ...options, mode: "server" });
}
// @__NO_SIDE_EFFECTS__
function useServerHeadSafe(input, options = {}) {
  return /* @__PURE__ */ useHeadSafe(input, { ...options, mode: "server" });
}
// @__NO_SIDE_EFFECTS__
function useServerSeoMeta(input, options = {}) {
  return /* @__PURE__ */ useSeoMeta(input, { ...options, mode: "server" });
}

export { useHeadSafe as a, useSeoMeta as b, useServerHead as c, useServerHeadSafe as d, useServerSeoMeta as e, injectHead as i, useHead as u };
